<template>
  <DataGridColumn header-class-name="data-grid-selection-header-column"
                  class-name="data-grid-selection-column"
                  v-bind="$attrs">
    <template slot="header" slot-scope="params">
      <div class="column-cont" v-if="!params.isHidden">
        <el-checkbox :disabled="params.$table.isAllCheckboxDisabled"
                     :indeterminate="params.$table.isIndeterminate"
                     :value="params.$table.isAllCheckboxDisabled ? false : params.$table.isAllSelected"
                     @change="checked => params.$table.triggerCheckAllEvent({}, checked)"></el-checkbox>
      </div>
    </template>
    <template slot-scope="params">
      <div class="column-cont" v-if="!params.isHidden">
        <el-checkbox :disabled="params.$table.checkboxOpts.checkMethod && !params.$table.checkboxOpts.checkMethod(params)"
                     :indeterminate="params.$table.treeConfig ? params.$table.treeIndeterminates.includes(params.row) : false"
                     :value="params.$table.selection.includes(params.row)"
                     @change="checked => params.$table.triggerCheckRowEvent({}, params, checked)"></el-checkbox>
      </div>
    </template>
  </DataGridColumn>
</template>

<script>
import DataGridColumn from '../../elements/DataGridColumn'
export default {
  name: 'DataGridSelectionColumn',
  components: {DataGridColumn}
}
</script>

<style lang="scss">
  .data-grid-selection-header-column,
  .data-grid-selection-column {
    .column-cont {
      padding-left: 3px;
      padding-right: 3px;
      .el-checkbox {
        .el-checkbox__input {
          & > .el-checkbox__inner {
            vertical-align: 1px;
          }
        }
      }
    }
    .vxe-cell--title {
      display: block!important;
      overflow: visible!important;
    }
  }
</style>
